import { ApprovalStatusType, FilterByType, OrderByType, SortByType } from 'app/model/constant';

import { ActHttpService } from 'app/services/act-http/act-http.service';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { ApprovalPageModel } from 'app/model/approval/approval-page';
import { ApprovalStatusModel } from 'app/model/approval/approval-status';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { environment } from 'environments/environment';
import { BookingCancellationStatus } from '../../model/booking/booking-cancellation';
import { BookingApprovalDetailModel } from '../../model/approval/approval-detail-model';

@Injectable()
export class ApprovalService {

  constructor(
    private actHttp: ActHttpService,
    private utilities: UtilitiesService,
    private appConfig: AppConfigService
  ) { }

  getApprovalList({ lang, page, limit, searchBy, filterBy, sortBy, orderBy, companyId}): Observable<ApprovalPageModel> {
    const options = this.actHttp.getRequestOptions();
    const url = `${environment.endpoint.getApprovalList}` +
      `?lang=${lang}` +
      `&page=${page}` +
      `&limit=${limit}` +
      `&search=` + encodeURIComponent(searchBy) +
      `&filter=${filterBy}` +
      `&sort=${sortBy}` +
      `&order=${orderBy}` +
      `&companyId=${companyId}`;
    return this.actHttp.get(url, options)
      .map((res: Response) => res.json().data);
  }

  getApprovalDetails(bookingId, companyId, bookingBookerId: number): Observable<BookingApprovalDetailModel> {
    const url = `${environment.endpoint.getApprovalDetails.replace('{bookingID}', bookingId)}?lang=${this.appConfig.getLanguage()}&companyId=${companyId}&bookingBookerId=${bookingBookerId}`;
    const options = this.actHttp.getRequestOptions();
    return this.actHttp.get(url, options)
      .map((res: Response) => res.json().data);
  }

  getApprovalSuggestion(bookingId: string = '', companyId: number): any {
    const options = this.actHttp.getRequestOptions();
    const url = `${environment.endpoint.getApprovalSuggestion}?bookingId=${bookingId}&companyId=${companyId}`;
    return this.actHttp.get(url, options)
      .map(res => res.json().data);
  }

  approveBooking(bookingId: number, ref: string, loggedIn: boolean = true): Observable<any> {
    const options = this.actHttp.getRequestOptions();
    const payload = {
      'bookingId': bookingId,
      'otp': ref
    };

    const result: Observable<any> = loggedIn ? this.actHttp.put(`${environment.endpoint.approve}`, payload, options) :
      this.actHttp.rawPut(`${environment.endpoint.approve}`, payload);
    return result.map((res: Response) => res);
  }

  rejectBooking(bookingId: number, ref: string, reason: string, loggedIn: boolean = true): Observable<Response> {
    const options = this.actHttp.getRequestOptions();
    const payload = {
      'bookingId': bookingId,
      'otp': ref,
      'reason': reason
    };

    const result: Observable<Response> = loggedIn ? this.actHttp.post(`${environment.endpoint.reject}`, payload, options) :
      this.actHttp.rawPost(`${environment.endpoint.reject}`, payload);
    return result.map((res: Response) => res);
  }

  getApprovalStatus({ approvalStatus, approvalDate, cancelDate }): ApprovalStatusModel {
    const formatStatusDate = `D MMM YY`;
    let keyStatus1 = '';
    let keyStatus2 = '';
    let keyPrefixDate = '';

    const status = new ApprovalStatusModel();

    switch (approvalStatus) {
      case ApprovalStatusType.APPROVE:
        keyStatus1 = `approval-list-status-approved`;
        keyPrefixDate = `approval-list-approved-date`;
        status.cssStatus = `green`;
        status.statusDate = approvalDate;
        status.status = ApprovalStatusType.APPROVE;
        break;
      case ApprovalStatusType.BOOKER_CANCELLED:
        keyStatus1 = `approval-list-status-booker-cancelled`;
        keyPrefixDate = `approval-list-cancel-date`;
        status.cssStatus = `grey`;
        status.statusDate = cancelDate;
        status.status = ApprovalStatusType.BOOKER_CANCELLED;
        break;
      case ApprovalStatusType.LAST_MINUTE:
        keyStatus1 = `approval-list-status-last-minute1`;
        keyStatus2 = `approval-list-status-last-minute2`;
        status.cssStatus = `orange`;
        status.status = ApprovalStatusType.LAST_MINUTE;
        break;
      case ApprovalStatusType.NO_ACTION:
        keyStatus1 = `approval-list-status-no-action`;
        status.cssStatus = `green`;
        status.status = ApprovalStatusType.NO_ACTION;
        break;
      case ApprovalStatusType.REJECT:
        keyStatus1 = `approval-list-status-rejected`;
        keyPrefixDate = `approval-list-rejected-date`;
        status.cssStatus = `red`;
        status.statusDate = approvalDate;
        status.status = ApprovalStatusType.REJECT;
        break;
      case ApprovalStatusType.PENDING:
        status.status = ApprovalStatusType.PENDING;
        break;
      default:
        status.status = ApprovalStatusType.UNKNOWN;
        break;
    }

    status.textStatus1 = keyStatus1 ? this.appConfig.getTranslate(keyStatus1) : undefined;
    status.textStatus2 = keyStatus2 ? this.appConfig.getTranslate(keyStatus2) : undefined;
    if (status.statusDate) {
      status.textStatusDate = this.appConfig.getTranslate(keyPrefixDate) + ' ' +
        this.utilities.convertDateFormat(status.statusDate, null, formatStatusDate);
    }

    return status;
  }

  getOrderByWithFilterAndSorting(filter: FilterByType, sortBy: SortByType): OrderByType {
    let orderBy = OrderByType.descending;
    if (filter === FilterByType.waiting && sortBy === SortByType.checkinDate) {
      orderBy = OrderByType.ascending;
    }
    return orderBy;
  }

  getBookingCancellationStatus(bookingId: number, otp: string): Observable<BookingCancellationStatus> {
    return this.actHttp.rawGet(
      `${environment.endpoint.getBookingCancellationStatus}` +
      `?bookingId=${bookingId}` +
      `&otp=${otp}`
    ).map(res => res.json().data);
  }

  updateBookingApprovalStatus(bookingId: string = '', ref: string = '', action: string = '') {
    return this.actHttp.rawPut(
      `${environment.endpoint.updateBookingApprovalStatus}/${action}`,
      { bookingId, ref }
    ).map(res => res.json().data);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/approval/approval.service.ts